import React, { useState, useContext, useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import axios from '../../../../axios/index';

import { Link } from 'react-router-dom';

// context
import { UserContext } from './../../../Context/UserContextProvider';

// styles
import styles from "./NoteDetail.module.css"
import Dstyles from "../../DashboardFileManagement/DashboardFileManagement.module.css"
import inputStyles from "../../Meeting/AddMeeting/AddMeeting.module.css"


// Re Useable Components
import DashboardSideMenu from '../../DashboardReuseAbleComponents/DashboardSideMenu';
import DashboardHeader from '../../DashboardReuseAbleComponents/DashboardHeader';
import ReminderModal from '../Reminder/ReminderModal';

//Images
import arrowIcon from "../../../../assets/img/DashboardICons/ArrowRounded.svg"

const NoteDetail = (props) => {
    // const id = props.match.params.id;
    const { state } = useLocation();
    console.log(state)
    const { userToken } = useContext(UserContext);
    const history = useHistory()
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    const [btnLoader, setBtnLoader] = useState(false)
    const [reminderData, setReminderData] = useState()
    const [isLoading, setIsLoading] = useState(true)
    const [addNoteInfo, setAddNoteInfo] = useState()
    const [showModal, setShowModal] = useState(false)
    const [addedReminderData, setAddedReminderData] = useState({
        title: "",
        hourValue: "",
        dateValue: ""
    })

    useMemo(() => addNoteInfo, [addNoteInfo])

    useEffect(() => {
        const dataHandler = async () => {
            const getNoteData = await axios.get(
                `Note/${state.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );

            const getApiData = await axios.get(
                `Reminder/2/${state.id}`,
                {
                    headers: { authorization: "Bearer " + userToken },
                }
            );

            setAddNoteInfo(getNoteData.data.data);
            setReminderData(getApiData.data.data)
            setIsLoading(false)
        }
        dataHandler()

    }, [state, userToken])

    return (
        <>
            <ReminderModal
                show={showModal}
                onHide={() => setShowModal(false)}
                addedReminderData={addedReminderData}
                setAddedReminderData={setAddedReminderData}
                id={state.id}
            />

            {isLoading ? (
                <div className={Dstyles.loader_container}>
                    <div className={Dstyles.spinner}></div>
                </div>
            )
                : (
                    <div className='container-fluid'>
                        <div className='row'>
                            <div className="col-md-9" >
                                <div className={`mt-3 px-0 ${Dstyles.container}`}>
                                    <DashboardHeader />

                                    {/* head title */}
                                    <div className="py-2">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                dir="rtl"
                                            >
                                                <div className='w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2'>
                                                    <div className='d-flex align-items-center justify-content-center'>
                                                        <a href='#' onClick={history.goBack}><img className='ms-2' src={arrowIcon} alt="icon" /></a>
                                                        <div className={Dstyles.text1}>
                                                            یادداشت‌ها
                                                        </div>
                                                    </div>

                                                    <div onClick={() => setShowModal(true)} className={`d-flex align-items-center justify-content-center ms-3 ${styles.add_btn_container}`} style={reminderData?.isActive === true ? { color: "#21409a" } : { color: "#8D8D8D" }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={
                                                            reminderData?.isActive === true ? "#21409a" : "#8D8D8D"
                                                        }
                                                            className="bi bi-alarm ms-2" viewBox="0 0 16 16">
                                                            <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z" />
                                                            <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z" />
                                                        </svg>
                                                        یادآور
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* head title */}

                                    {/* inputs */}
                                    <div className="py-2">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                dir="rtl"
                                            >
                                                <div className='w-100 d-flex flex-column justify-content-center align-items-center'>
                                                    <div className="d-flex align-items-start justify-content-center flex-column my-3 w-100">
                                                        <div className={`mb-3 ${inputStyles.input_top_title}`}>
                                                            عنوان یادداشت
                                                        </div>
                                                        <input
                                                            className={`w-100 ${inputStyles.input}`}
                                                            type="text"
                                                            name="title"
                                                            value={addNoteInfo?.title}
                                                            onChange={changeHandler}
                                                        />
                                                    </div>
                                                    <div className='w-100 d-flex flex-column justify-content-center align-items-start my-4'>
                                                        <div className={`mb-3 ${inputStyles.input_top_title}`}>
                                                            متن یادداشت
                                                        </div>
                                                        <textarea
                                                            type="text"
                                                            name="description"
                                                            value={addNoteInfo?.description}
                                                            className={`w-100 px-3 pt-3 ${styles.textarea}`}
                                                            onChange={changeHandler}
                                                        ></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* inputs */}

                                    {/* date info */}
                                    <div className="py-2 mb-4">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                dir="rtl"
                                            >
                                                <div className={`w-100 d-flex align-items-center justify-content-around flex-wrap py-md-0 py-2 ${styles.date_detail_container}`}>
                                                    <div className='d-flex align-items-center m-md-0 my-2'>
                                                        <div className={`d-flex align-items-center justify-content-center ms-2 ${styles.icon_container}`}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill={
                                                                reminderData?.isActive === true ? "#21409a" : "#8D8D8D"
                                                            } className=" bi bi-alarm"
                                                                viewBox="0 0 16 16">
                                                                <path d="M8.5 5.5a.5.5 0 0 0-1 0v3.362l-1.429 2.38a.5.5 0 1 0 .858.515l1.5-2.5A.5.5 0 0 0 8.5 9V5.5z" />
                                                                <path d="M6.5 0a.5.5 0 0 0 0 1H7v1.07a7.001 7.001 0 0 0-3.273 12.474l-.602.602a.5.5 0 0 0 .707.708l.746-.746A6.97 6.97 0 0 0 8 16a6.97 6.97 0 0 0 3.422-.892l.746.746a.5.5 0 0 0 .707-.708l-.601-.602A7.001 7.001 0 0 0 9 2.07V1h.5a.5.5 0 0 0 0-1h-3zm1.038 3.018a6.093 6.093 0 0 1 .924 0 6 6 0 1 1-.924 0zM0 3.5c0 .753.333 1.429.86 1.887A8.035 8.035 0 0 1 4.387 1.86 2.5 2.5 0 0 0 0 3.5zM13.5 1c-.753 0-1.429.333-1.887.86a8.035 8.035 0 0 1 3.527 3.527A2.5 2.5 0 0 0 13.5 1z" />
                                                            </svg>
                                                        </div>
                                                        <div className={styles.date_detail_text}>
                                                            {reminderData?.title ? reminderData.title : "یادآور"}
                                                        </div>
                                                    </div>

                                                    <div className='d-flex align-items-center m-md-0 my-2'>
                                                        <div className="d-flex align-items-center justify-content-center ms-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#8D8D8D" className="ms-3 bi bi-calendar" viewBox="0 0 16 16">
                                                                <path d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z" />
                                                            </svg>
                                                            <p className={`m-0 ${styles.text_gray}`}>
                                                                تاریخ:
                                                            </p>
                                                        </div>
                                                        <div className={styles.date_detail_text}>
                                                            {reminderData?.reminderDate ?
                                                                e2p(reminderData?.reminderDate)
                                                                :
                                                                "یادآور تنظیم نشده است"
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className='d-flex align-items-center m-md-0 my-2'>
                                                        <div className="d-flex align-items-center justify-content-center ms-2">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="#8D8D8D" className="ms-3 bi bi-clock" viewBox="0 0 16 16">
                                                                <path d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z" />
                                                                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
                                                            </svg>
                                                            <p className={`m-0 ${styles.text_gray}`}>
                                                                ساعت:
                                                            </p>
                                                        </div>
                                                        <div className={styles.date_detail_text}>
                                                            {reminderData?.reminderTime ?
                                                                e2p(reminderData?.reminderTime)
                                                                :
                                                                "یادآور تنظیم نشده است"
                                                            }
                                                        </div>
                                                    </div>

                                                    <div className={` ${styles.text_primary}`} onClick={reminderHandler}>
                                                        {
                                                            reminderData?.isActive === true ? "غیرفعال سازی" : "یادآور تنظیم نشده است"
                                                        }
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* date info */}

                                    {/* buttons */}
                                    <div className="py-2 mb-4">
                                        <div className="container-fluid">
                                            <div
                                                className="d-flex justify-content-md-between justify-content-center flex-wrap align-items-center mt-3 me-3"
                                                dir="rtl"
                                            >
                                                {/* <Link to={`/delete-note/${addNoteInfo?.id}`} className='d-flex align-items-center justify-content-center ms-4'>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" fill="#E00000" className="ms-2 bi bi-trash3" viewBox="0 0 16 16">
                                                        <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z" />
                                                    </svg>
                                                    <div className={styles.text_danger}>
                                                        حذف فایل
                                                    </div>
                                                </Link> */}

                                                <div className='w-100 d-flex align-items-center justify-content-end'>
                                                    {btnLoader ? (
                                                        <div className={Dstyles.btn_loader_container}>
                                                            <div className={Dstyles.btn_spinner}></div>
                                                        </div>
                                                    )
                                                        : (
                                                            <button type="submit" className={`btn me-3 ${styles.submit_btn}`} onClick={editNoteHandler}>
                                                                ویرایش
                                                            </button>
                                                        )
                                                    }

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* buttons */}

                                </div>
                            </div>
                            <div className='col-md-3'>
                                {/* sideMenu starts */}
                                <DashboardSideMenu notes />
                                {/* sideMenu ends */}
                            </div>
                        </div>
                    </div>
                )}
        </>
    );

    function changeHandler(event) {
        setAddNoteInfo((prev) => {
            return { ...prev, [event.target.name]: event.target.value };
        });
    };

    async function editNoteHandler() {
        setBtnLoader(true)
        var editData = new FormData();
        editData.append('id', state.id);
        editData.append('Title', addNoteInfo.title);
        editData.append('Description', addNoteInfo.description);

        const apiData = await axios.put(
            "Note",
            editData,
            {
                headers: { authorization: "Bearer " + userToken },
            }
        );
        history.push('/my-notes')

        // if (contextData.reminderData.reminderStatus === true) {
        //     const RminderTitle = contextData.reminderData.title
        //     const RminderReminderDate = `${contextData?.dateValue.year}/${contextData?.dateValue.month.number}/${contextData?.dateValue.day}`
        //     const RminderReminderTime = `${contextData?.hourValue.hour}:${contextData?.hourValue.minute}`

        //     var data = new FormData();
        //     data.append('ObjectId', id);
        //     data.append('ReminderFor', 2);
        //     data.append('Title', RminderTitle);
        //     data.append('ReminderDate', RminderReminderDate);
        //     data.append('ReminderTime', RminderReminderTime);

        //     const apiData = await axios.post(
        //         "Reminder",
        //         data,
        //         {
        //             headers: { authorization: "Bearer " + userToken },
        //         }
        //     );

        //     props.history.replace("/my-notes");
        // }
    }

    async function reminderHandler() {
        var data = {
            "reminderId": reminderData?.id
        };

        const postApiData = await axios.delete(
            "Reminder/DeleteReminder",
            {
                data: data,
                headers: {
                   authorization: "Bearer " + userToken 
                },
            }
        );
    }
};

export default NoteDetail;